import React, { forwardRef, useEffect, useLayoutEffect } from 'react';
import { backdropClasses } from '@mui/material';

import { RootContainers } from '@/modules/common/helpers';
import { omitUndefinedProps } from '@/mui/helpers';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// let paddingRight: string | undefined;
// let overflow: string | undefined;

const Backdrop = forwardRef<HTMLDivElement>((props, ref) => {
  useIsomorphicLayoutEffect(() => {
    // paddingRight = document.body.style.paddingRight ?? undefined;
    // overflow = document.body.style.overflow ?? undefined;

    const { width: beginningWidth } = document.body.getBoundingClientRect();

    document.body.style.overflow = 'hidden';

    const { width: updatedWidth } = document.body.getBoundingClientRect();

    document.body.style.paddingRight = `${Math.max(0, updatedWidth - beginningWidth)}px`;

    return () => {
      const backdrop = RootContainers.getMUIPortalContainer().querySelectorAll(`.${backdropClasses.root}`);

      if (backdrop.length <= 1) {
        document.body.style.paddingRight = /* paddingRight ?? */ '';
        document.body.style.overflow = /* overflow ?? */ '';
      }
    };
  }, []);

  return <div {...omitUndefinedProps(props)} ref={ref} />;
});

Backdrop.displayName = 'Backdrop';

export default Backdrop;
